import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import Select from 'react-select';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const EditCoupons = ({ coupon, onRefresh }) => {
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [type, setType] = useState({ value: 'Fixed', label: 'Fixed' });
    const [discount, setDiscount] = useState('');
    const [limit, setLimit] = useState(0);
    const [validUntil, setValidUntil] = useState(null);
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        if (coupon) {
            setName(coupon.name);
            setCode(coupon.code);
            setType({ value: coupon.type, label: coupon.type });
            setDiscount(coupon.discount);
            setLimit(coupon.limit);
            setValidUntil(coupon.validUntil);
            setIsActive(coupon.isActive);
        }
    }, [coupon]);

    const typeOptions = [
        { value: 'Fixed', label: 'Fixed' },
        { value: 'Percentage', label: 'Percentage' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const d = Number(discount);
        const lim = Number(limit);
        if (!Number.isFinite(d) || d < 0) {
            Swal.fire('Invalid value', 'Discount must be zero or positive', 'error');
            return;
        }
        if (type.value === 'Percentage' && d > 100) {
            Swal.fire('Invalid value', 'Percentage discount cannot exceed 100', 'error');
            return;
        }
        if (!Number.isFinite(lim) || lim < 0) {
            Swal.fire('Invalid value', 'Usage limit cannot be negative', 'error');
            return;
        }
        try {
            const payload = {
                name,
                code,
                type: type.value,
                discount: d,
                limit: lim,
                validUntil,
                isActive
            };
            await axios.put(`https://avastar-pos-backend.onrender.com/api/coupons/${coupon._id}`, payload);
            Swal.fire('Success', 'Coupon updated successfully', 'success');
            onRefresh();
            document.getElementById('close-edit-coupon').click();
        } catch (error) {
            Swal.fire('Error', error.response?.data?.message || 'Failed to update coupon', 'error');
        }
    };

    return (
        <div className="modal fade" id="edit-units">
            <div className="modal-dialog modal-dialog-centered custom-modal-two">
                <div className="modal-content">
                    <div className="page-wrapper-new p-0">
                        <div className="content">
                            <div className="modal-header border-0 custom-modal-header">
                                <div className="page-title">
                                    <h4>Edit Coupon</h4>
                                </div>
                                <button type="button" id="close-edit-coupon" className="close" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">Ã—</span>
                                </button>
                            </div>
                            <div className="modal-body custom-modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Name</label>
                                                <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Code</label>
                                                <input type="text" className="form-control" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Type</label>
                                                <Select className="select" options={typeOptions} value={type} onChange={(val) => setType(val)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Discount</label>
                                                <input type="number" min="0" max={type.value === 'Percentage' ? 100 : undefined} step="any" className="form-control" value={discount} onChange={(e) => setDiscount(e.target.value)} required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="mb-3">
                                                <label className="form-label">Limit</label>
                                                <input type="number" min="0" className="form-control" value={limit} onChange={(e) => setLimit(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="mb-3">
                                                <label className="form-label">Valid Until</label>
                                                <DatePicker className="form-control" value={validUntil ? dayjs(validUntil) : null} onChange={(date) => setValidUntil(date ? date.toDate() : null)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center mb-3">
                                                <span className="status-label">Status</span>
                                                <input type="checkbox" id="edit-active-check" className="check" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                                                <label htmlFor="edit-active-check" className="checktoggle"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer-btn">
                                        <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">Cancel</button>
                                        <button type="submit" className="btn btn-submit">Save Changes</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

EditCoupons.propTypes = {
    coupon: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
        code: PropTypes.string,
        type: PropTypes.string,
        discount: PropTypes.number,
        limit: PropTypes.number,
        validUntil: PropTypes.string,
        isActive: PropTypes.bool
    }),
    onRefresh: PropTypes.func.isRequired,
};

export default EditCoupons
